import { useState, useEffect, useCallback } from 'react';

const useRedirectLoading = () => {
    const [redirectLoading, setRedirectLoading] = useState<boolean>(false);

    const startRedirectLoading = useCallback(() => setRedirectLoading(true), []);

    useEffect(() => {
        function handlePageShow(event: PageTransitionEvent) {
            // If the page was restored from the bfcache, we reset the loading value
            if (event.persisted) {
                setRedirectLoading(false);
            }
        }
        window.addEventListener('pageshow', handlePageShow);

        return () => {
            window.removeEventListener('pageshow', handlePageShow);
        };
    }, []);

    return { redirectLoading, startRedirectLoading };
};

export default useRedirectLoading;
